import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import ProjectionField from 'modules/reports/components/Editor/Carcasa/FormFields/ProjectionField'
import { FieldSelectionType } from 'modules/reports/hooks/useReportTracking'
import { ABILITIES, TYPES } from 'modules/reports/lib/Constants'
import type { ReportEditorStore } from 'modules/reports/lib/Store'

interface Props {
  store: ReportEditorStore
}

const NumericMetricFormView = (props: Props) => {
  const { store } = props

  const label = {
    text: i18n.t('custom_reports.fields.numeric.initial_data.title'),
    tooltipText: i18n.tView('custom_reports.fields.numeric.initial_data.tooltip', {}),
  }

  return (
    <>
      <ProjectionField
        selectionType={FieldSelectionType.Data}
        store={store}
        formIndex={0}
        buttonLabel={i18n.t('custom_reports.fields.numeric.initial_data.button')}
        fieldAbilityTypes={[ABILITIES.aggregation, ABILITIES.ordering]}
        label={label}
        excludeTypes={[
          TYPES.cohort,
          TYPES.text,
          TYPES.date,
          TYPES.enum,
          TYPES.link,
          TYPES.unit,
          TYPES.boolean,
        ]}
      />
    </>
  )
}

export default NumericMetricFormView
